import { sendPostCallToSever } from "../Axios/Axios";

const ContactUsPost = (payload, setOpen) => () => {
  return sendPostCallToSever(payload, "contact").then(() => {
    setOpen(false);
    return true;
  });
};

export { ContactUsPost };
